import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const stepGridColumns = () => [
    {
        field: 'from_activity',
        cellStyle: { 
            color: '#172B4D'
        },
        headerName: 'From Activity',
        flex: 1
    },
    {
        field: 'to_activity',
        cellStyle: { 
            color: '#172B4D'
        },
        headerName: 'To Activity',
        flex: 1
    },
    {
        field: 'tasks',
        headerName: 'Work Items',
        filter: 'agNumberColumnFilter',
        width: 130,
        hide: false,
        cellStyle: { 
            textAlign: 'center',
            color: '#172B4D'
        },
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },
    {
        field: 'perc_total_tasks',
        headerName: '% Total ',
        filter: 'agNumberColumnFilter',
        width: 125,
        hide: false,
        cellStyle: { 
            padding: '8px 12px',
            display: 'flex',
            textAlign: 'center',
            color: '#172B4D'
        },
        valueFormatter: ({ value }) => {
            if (value == null || !isFinite(value)) return '—';
            return apiProvider.formatPercentage({ perc: value, decimals: 1 });
        },
    },
    {
        field: 'avg_duration',
        headerName: 'Avg Duration',
        filter: 'agNumberColumnFilter',
        width: 140,
        cellStyle: { 
            textAlign: 'center',
            color: '#172B4D'
        },
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
    {
        field: 'total_duration',
        headerName: 'Total Duration',
        filter: 'agNumberColumnFilter',
        width: 140,
        cellStyle: { 
            textAlign: 'center',
            color: '#172B4D'
        },
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
        {
        headerName: "Std Deviation",
        field: "std_deviation",
        width: 140,
        valueFormatter: ({ value }) => apiProvider.formatDuration({ seconds: value }),
        cellStyle: { 
            textAlign: 'center',
            color: '#172B4D'
        }
    }
   ];